<template>
    <v-layout-item
        class="scroll-to-top-btn"
        v-scroll="onScroll"
        position="bottom"
        size="88"
        model-value
    >
        <div class="ma-4">
            <v-slide-x-reverse-transition>
                <v-btn
                    v-show="model"
                    @click="onClick"
                    class="mt-auto"
                    color="secondary"
                    elevation="3"
                    :icon="mdiChevronUp"
                    size="large"
                />
            </v-slide-x-reverse-transition>
        </div>
    </v-layout-item>
</template>

<script lang="ts" setup>
    import { mdiChevronUp } from '@mdi/js';

    const model = ref(false);

    function onScroll(): void {
        model.value = window.scrollY > 200;
    }

    function onClick(): void {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
</script>

<style lang="scss">
.scroll-to-top-btn {
    left: unset !important;
    right: 0 !important;
    width: auto !important;
}
</style>
